import { AppSwitchComponent } from "./appSwitch";

export const AppSwitch = AppSwitchComponent;
